export default __webpack_public_path__ + "static/media/profile.28e44cb7.png";